import { useId } from "react";
import type { CSSProperties } from "react";

type NmGlowOverlayProps = {
  height?: number | string;
  opacity?: number;
  startColor?: string;
  endColor?: string;
  style?: CSSProperties;
};

export function NmGlowOverlay({
  height = "20vh",
  opacity = 0.3,
  startColor = "rgba(240, 255, 49, 1)",
  endColor = "rgba(47, 47, 47, 0)",
  style,
}: NmGlowOverlayProps) {
  const gradientId = useId();

  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        top: 0,
        height,
        opacity,
        pointerEvents: "none",
        ...style,
      }}>
      <svg width="100%" height="100%" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id={`nmGlowOverlayGrad-${gradientId}`} x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor={startColor} stopOpacity="1" />
            <stop offset="100%" stopColor={endColor} stopOpacity="0" />
          </linearGradient>
        </defs>
        <rect width="100%" height="100%" fill={`url(#nmGlowOverlayGrad-${gradientId})`} />
      </svg>
    </div>
  );
}
